import { APIHooksKeysEnum } from 'enums/APIHooksKeysEnum'
import { notificationController } from 'notificationController/notificationController'
import { useQuery } from 'react-query'
import { toolsService } from 'services/tools.service'

const getTaskProgress = async (taskID: string) => {
  const { data } = await toolsService.getTaskProgress(taskID)

  return data
}

export const useGetTaskProgress = (taskID) => {
  const query = useQuery(
    [APIHooksKeysEnum.GET_TASK_PROGRESS, taskID],
    () => getTaskProgress(taskID),
    {
      // Refetch every 2 seconds if the task is still running
      enabled: Boolean(taskID),
      refetchInterval: (data) =>
        !data || data.progress.current < 100 ? 2000 : undefined,
      onError: (error) => {
        notificationController.show({
          description:
            (error as Error).message || 'Failed to fetch task progress',
          status: 'error',
        })
      },
    }
  )

  return query
}
